import { useApi } from '@/api'
import type {
    ChartRangesV1,
    GetMonitorChartV3Request,
    GetVesselChartV3Request,
    GetVesselWaterReportChartsV1Request,
    MonitorChartActionV1,
    MonitorChartsV3
} from '@geckoal/gecko-api-client'
import type { ChartDataStreams, ChartsKeys, DataStreamValue } from '@geckoal/gecko-webapp-utils'
import type { Duration } from 'date-fns'

export type CrystalAPIMonitorCharts = {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    charts?: ChartDataStreams<any>
    startDate: Date
    endDate: Date
    bucketInterval: Duration
    source: string
    ranges?: ChartRangesV1
    completedPhActions?: MonitorChartActionV1[]
    completedOrpActions?: MonitorChartActionV1[]
}

export class CrystalAPIMonitorChartFetcher {
    async getVesselChart(options: GetVesselChartV3Request): Promise<CrystalAPIMonitorCharts> {
        const result = await useApi().getVesselChartV3({
            ...options
        })
        return this.convertV3(result)
    }

    async getMonitorChart(options: GetMonitorChartV3Request): Promise<CrystalAPIMonitorCharts> {
        const result = await useApi().getMonitorChartV3({
            ...options
        })
        return this.convertV3(result)
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    async getWaterReportChart(options: GetVesselWaterReportChartsV1Request): Promise<ChartDataStreams<any>> {
        const result = await useApi().getVesselWaterReportChartsV1({
            ...options
        })

        const { date, ...others } = result
        const mappedOthers = others as { [Property in ChartsKeys]?: DataStreamValue[] }

        return {
            dates: date as unknown as string[],
            streams: {
                ...mappedOthers
            }
        }
    }

    private convertV3(chartData: MonitorChartsV3): CrystalAPIMonitorCharts {
        const output: CrystalAPIMonitorCharts = {
            startDate: chartData.startDate,
            endDate: chartData.endDate,
            bucketInterval: chartData.bucketInterval,
            source: chartData.source,
            ranges: chartData.ranges,
            completedPhActions: chartData.completedPhActions,
            completedOrpActions: chartData.completedOrpActions
        }

        if (chartData.chart) {
            const { sampleDate, ...others } = chartData.chart

            const mappedOthers = others as { [Property in ChartsKeys]?: DataStreamValue[] }

            output.charts = {
                dates: sampleDate as unknown as string[],
                streams: {
                    ...mappedOthers
                }
            }
        }

        return output
    }
}
